import React from "react";

const LoadingSpinner = ({ height = "60vh" }) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: height }}
    >
      <div className="spinner-grow text-secondary bg-accent" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default LoadingSpinner;
